import React from "react";
import AdminLayout from "../../../components/Layout/AdminLayout";
import CarDocumentList from "./CarDocumentList";

export default async function action({ params, store }) {
  const title = "Car Document Approvals";

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: "/siteadmin/login" };
  }
  const { listId } = params;

  // Admin restriction
  //   if (!restrictUrls('/siteadmin/carDocuments', adminPrivileges, privileges)) {
  //     return { redirect: '/siteadmin' };
  //   }
  return {
    title,
    component: (
      <AdminLayout>
        <CarDocumentList title={title} listId={listId} />
      </AdminLayout>
    ),
  };
}
